import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import {
  Container,
  Button,
  Row,
  Col,
  Table,
  Form,
  Spinner,
} from "react-bootstrap";
import EditNoteIcon from "@mui/icons-material/EditNote";
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";
import { CSVLink } from "react-csv";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf, faFileVideo } from "@fortawesome/free-solid-svg-icons";
import PageContentEditor from "../components/PageContentEditor";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";

const CourseFragment = ({
  onCourseClick,
  company,
  department,
  onTransactionsClick,
}) => {
  const getDefaultDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = "10";
    const minutes = "00";

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const [imageUrls, setImageUrls] = useState([]);
  const [courseThumb, setCourseThumb] = useState([]);
  const [courses, setCourses] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [category] = useState([
    { _id: 1, name: "Category 1" },
    { _id: 2, name: "Category 2" },
  ]);
  const [selectedCompany, setSelectedCompany] = useState(company);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    company: "",
    department: "",
    designation: "",
    userID: localStorage.getItem("userId"), // Assuming you have the userID
    thumbnail: null,
    dueDate: null,
    schedule: getDefaultDateTime(),
    selectedThumb: "",
    modules: [],
    // Website content fields
    slug: "",
    shortDescription: "",
    websiteLevel: "",
    duration: "",
    language: "English",
    certifications: true,
    pageContent: "",
    price: "",
    originalPrice: "",
  });
  const [categoryQuiz, setCategoryQuiz] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [isList, setIsList] = useState(true);
  const [showRawJson, setShowRawJson] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(7);
  const [searchQuery, setSearchQuery] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [designations, setDesignations] = useState([]);
  const [roles, setRoles] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    fetchCompanies();
    fetchThumbnails();
    fetchMaterials();
    fetchCategoryQuiz();
  }, []);

  useEffect(() => {
    fetchRoles();
    fetchDepartments();
    fetchDesignations();
  }, []);

  useEffect(() => {
    fetchCourses(currentPage);
  }, [
    currentPage,
    itemsPerPage,
    selectedCompany,
    selectedCategory,
    searchQuery,
  ]); // Add formData.company to the dependencies

  const fetchRoles = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", localStorage.getItem("token"));
      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };
      fetch(`${API_URL}/role`, requestOptions)
        .then((response) => {
          if (response.status == 401) {
            localStorage.clear();
            window.location.reload();
            return [];
          } else {
            return response.json();
          }
        })
        .then((result) => setRoles(result))
        .catch((error) => console.error(error));
    } catch (error) {
      console.error(error);
    }
  };

  const fetchDepartments = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", localStorage.getItem("token"));
      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };
      fetch(`${API_URL}/department`, requestOptions)
        .then((response) => {
          if (response.status == 401) {
            localStorage.clear();
            window.location.reload();
            return [];
          } else {
            return response.json();
          }
        })
        .then((result) => setDepartments(result))
        .catch((error) => console.error(error));
    } catch (error) {
      console.error(error);
    }
  };

  const fetchDesignations = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", localStorage.getItem("token"));
      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };
      fetch(`${API_URL}/designation`, requestOptions)
        .then((response) => {
          if (response.status == 401) {
            localStorage.clear();
            window.location.reload();
            return [];
          } else {
            return response.json();
          }
        })
        .then((result) => setDesignations(result))
        .catch((error) => console.error(error));
    } catch (error) {
      console.error(error);
    }
  };

  const fetchMaterials = async (currentPage) => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", localStorage.getItem("token"));
      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };
      let apiUrl = `${API_URL}/admin/courses?page=1&limit=100000`;
      // if (selectedType) {
      //     apiUrl += `&type=${selectedType}`;
      // }
      const response = await fetch(apiUrl, requestOptions);
      if (response.status === 401) {
        localStorage.clear();
        window.location.reload();
        return;
      }
      const data = await response.json();
      setCourseThumb(data.courses);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchThumbnails = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", localStorage.getItem("token"));
      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };
      let apiUrl = `${API_URL}/admin/thumbnails`;
      const response = await fetch(apiUrl, requestOptions);
      if (response.status === 401) {
        localStorage.clear();
        window.location.reload();
        return;
      }
      const data = await response.json();
      setImageUrls(data.thumbnail);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchCategoryQuiz = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", localStorage.getItem("token"));
      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };
      fetch(`${API_URL}/categoryQuiz`, requestOptions)
        .then((response) => {
          if (response.status == 401) {
            localStorage.clear();
            window.location.reload();
            return [];
          } else {
            return response.json();
          }
        })
        .then((result) => {
          setCategoryQuiz(result);
        })
        .catch((error) => console.error(error));
    } catch (error) {
      console.error(error);
    }
  };

  const fetchCourses = async (page) => {
    console.log(selectedCompany);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", localStorage.getItem("token"));
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    let apiUrl = `${API_URL}/admin/courses-main?page=${page}&limit=${itemsPerPage}`;
    if (selectedCompany) {
      apiUrl += `&companyId=${selectedCompany}`; // Append company ID if selected
    }
    if (selectedCategory) {
      apiUrl += `&category=${selectedCategory}`; // Append company ID if selected
    }
    if (searchQuery) {
      apiUrl += `&searchQuery=${searchQuery}`; // Append search query
    }
    fetch(apiUrl, requestOptions)
      .then((response) => {
        if (response.status === 401) {
          localStorage.clear();
          window.location.reload();
          return [];
        } else {
          return response.json();
        }
      })
      .then((result) => {
        console.log(result);
        setCourses(result.courses);
        setTotalPages(result.totalPages);
        setCurrentPage(result.currentPage);
      })
      .catch((error) => console.error(error));
  };

  const fetchCompanies = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", localStorage.getItem("token"));
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    fetch(`${API_URL}/admin/companies`, requestOptions)
      .then((response) => {
        if (response.status == 401) {
          localStorage.clear();
          window.location.reload();
          return [];
        } else {
          return response.json();
        }
      })
      .then((result) => setCompanies(result))
      .catch((error) => console.error(error));
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      var isPngOrJpg = true;
      if (formData.thumbnail) {
        const fileName = formData.thumbnail.name;
        isPngOrJpg = /\.(png|jpg)$/i.test(fileName);
      }

      if (isPngOrJpg) {
        const scheduleDate = new Date(formData.schedule);
        const dueDate = new Date(formData.dueDate);
        if (dueDate && scheduleDate > dueDate) {
          alert("Schedule date cannot be after the due date.");
        } else {
          setIsLoading(true);
          const myHeaders = new Headers();
          myHeaders.append("Authorization", localStorage.getItem("token"));
          const formdata = new FormData();
          if (formData.thumbnail) {
            formdata.append(
              "thumbnail",
              formData.thumbnail,
              formData.thumbnail.name,
            );
          }
          formdata.append("company", formData.company);
          formdata.append("userID", localStorage.getItem("userId"));
          formdata.append("dueDate", formData.dueDate);
          formdata.append("schedule", formData.schedule);
          formdata.append("type", formData.type);
          formdata.append("department", formData.department);
          formdata.append("designation", formData.designation);
          formdata.append("selectedThumb", formData.selectedThumb);
          formdata.append("title", formData.title);
          formdata.append("description", formData.description || " ");
          formdata.append("modules", JSON.stringify(formData.modules));
          // Website content fields
          if (formData.slug) formdata.append("slug", formData.slug);
          if (formData.shortDescription)
            formdata.append("shortDescription", formData.shortDescription);
          if (formData.websiteLevel)
            formdata.append("websiteLevel", formData.websiteLevel);
          if (formData.duration) formdata.append("duration", formData.duration);
          if (formData.language) formdata.append("language", formData.language);
          formdata.append("certifications", formData.certifications);
          if (formData.pageContent)
            formdata.append("pageContent", formData.pageContent);
          if (formData.price) formdata.append("price", formData.price);
          if (formData.originalPrice)
            formdata.append("originalPrice", formData.originalPrice);
          const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: formdata,
            redirect: "follow",
          };
          const logoResponse = await fetch(
            `${API_URL}/admin/courses-main`,
            requestOptions,
          );

          if (!logoResponse.ok) {
            alert("Failed to create course, please try again!!");
            throw new Error("Failed to upload logo");
          }
          setFormData({
            title: "",
            description: "",
            company: "",
            department: "",
            designation: "",
            userID: localStorage.getItem("userId"),
            thumbnail: null,
            dueDate: null,
            schedule: getDefaultDateTime(),
            selectedThumb: null,
            modules: [],
            slug: "",
            shortDescription: "",
            websiteLevel: "",
            duration: "",
            language: "English",
            certifications: true,
            pageContent: "",
            price: "",
            originalPrice: "",
          });
          alert("Course created successfully!!");
          await fetchCourses();
          setIsLoading(false);
          setIsList(true);
        }
      } else {
        alert("Thumbnail can only contain png or jpg.");
      }
    } catch (error) {
      console.log(error);
      alert("Failed to create course, please try again!!");
      setIsLoading(false);
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      var isPngOrJpg = true;
      if (formData.thumbnail) {
        const fileName = formData.thumbnail.name;
        isPngOrJpg = /\.(png|jpg)$/i.test(fileName);
      }

      if (isPngOrJpg) {
        const scheduleDate = new Date(formData.schedule);
        const dueDate = new Date(formData.dueDate);
        if (dueDate && scheduleDate > dueDate) {
          alert("Schedule date cannot be after the due date.");
        } else {
          setIsLoading(true);
          const myHeaders = new Headers();
          myHeaders.append("Authorization", localStorage.getItem("token"));
          const formdata = new FormData();
          if (formData.thumbnail) {
            formdata.append(
              "thumbnail",
              formData.thumbnail,
              formData.thumbnail.name,
            );
          }
          formdata.append("company", formData.company);
          formdata.append("userID", localStorage.getItem("userId"));
          formdata.append("dueDate", formData.dueDate);
          formdata.append("schedule", formData.schedule);
          formdata.append("department", formData.department);
          formdata.append("designation", formData.designation);
          formdata.append("selectedThumb", formData.selectedThumb);
          formdata.append("title", formData.title);
          formdata.append("description", formData.description || " ");
          formdata.append("modules", JSON.stringify(formData.modules));
          // Website content fields
          if (formData.slug) formdata.append("slug", formData.slug);
          if (formData.shortDescription)
            formdata.append("shortDescription", formData.shortDescription);
          if (formData.websiteLevel)
            formdata.append("websiteLevel", formData.websiteLevel);
          if (formData.duration) formdata.append("duration", formData.duration);
          if (formData.language) formdata.append("language", formData.language);
          formdata.append("certifications", formData.certifications);
          if (formData.pageContent)
            formdata.append("pageContent", formData.pageContent);
          if (formData.price) formdata.append("price", formData.price);
          if (formData.originalPrice)
            formdata.append("originalPrice", formData.originalPrice);
          const requestOptions = {
            method: "PUT",
            headers: myHeaders,
            body: formdata,
            redirect: "follow",
          };
          const response = await fetch(
            `${API_URL}/admin/courses-main/${formData.courseIdToUpdate}`,
            requestOptions,
          );
          if (!response.ok) {
            throw new Error("Failed to update course");
          }
          setFormData({
            title: "",
            description: "",
            company: "",
            department: "",
            designation: "",
            userID: localStorage.getItem("userId"),
            thumbnail: null,
            dueDate: null,
            schedule: getDefaultDateTime(),
            selectedThumb: null,
            modules: [],
            slug: "",
            shortDescription: "",
            websiteLevel: "",
            duration: "",
            language: "English",
            certifications: true,
            pageContent: "",
            price: "",
            originalPrice: "",
          });
          alert("Course updated successfully!");
          await fetchCourses();
          setIsEdit(false);
          setIsLoading(false);
          setIsList(true);
        }
      } else {
        alert("Thumbnail can only contain png or jpg.");
      }
    } catch (error) {
      alert("Failed to update course, please try again!");
      setIsLoading(false);
    }
  };

  const handleFileChange = (e) => {
    if (
      e.target.files[0].name.includes("png") ||
      e.target.files[0].name.includes("jpg")
    ) {
      setFormData({ ...formData, thumbnail: e.target.files[0] });
    }
  };

  const handleConsentFile = (e) => {
    setFormData({ ...formData, consentFile: e.target.files[0] });
  };

  const handleEdit = (course) => {
    let scheduleValue = getDefaultDateTime();
    if (course.schedule) {
      const d = new Date(course.schedule);
      if (!isNaN(d.getTime())) {
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        const hours = String(d.getHours()).padStart(2, "0");
        const minutes = String(d.getMinutes()).padStart(2, "0");
        scheduleValue = `${year}-${month}-${day}T${hours}:${minutes}`;
      }
    }
    setFormData({
      courseIdToUpdate: course._id,
      title: course.title,
      description: course.description,
      company: course.company._id,
      department: course.department?._id || "",
      designation: course.designation?._id || "",
      dueDate: course.dueDate
        ? new Date(course.dueDate).toISOString().split("T")[0]
        : "",
      schedule: scheduleValue,
      courseIdToUpdate: course._id, // Set courseIdToUpdate to the ID of the course being edited
      modules: course.modules,
      // Website content fields
      slug: course.slug || "",
      shortDescription: course.shortDescription || "",
      websiteLevel: course.level || "",
      duration: course.duration || "",
      language: course.language || "English",
      certifications: course.certifications !== false,
      pageContent: course.pageContent
        ? JSON.stringify(course.pageContent, null, 2)
        : "",
      price: course.price || "",
      originalPrice: course.originalPrice || "",
    });
    setIsEdit(true);
    setIsList(false);
  };

  const handleDelete = async (courseId) => {
    // Display confirmation popup before deleting
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this course?",
    );
    if (!isConfirmed) return; // If user cancels, do nothing

    try {
      const token = localStorage.getItem("token"); // Get the authentication token
      const requestOptions = {
        method: "DELETE",
        headers: { "Content-Type": "application/json", Authorization: token },
      };

      const response = await fetch(
        `${API_URL}/course-main/${courseId}`,
        requestOptions,
      );

      if (response.ok) {
        alert("Course deleted successfully");
        fetchCourses(currentPage);
      } else {
        alert("Failed to delete course");
      }
    } catch (error) {
      console.error("Error deleting course:", error);
      alert("Failed to delete course");
    }
  };

  function capitalizeFirstLetter(string) {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const filteredThumbnails = courseThumb.filter((url) =>
    url.title.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  return (
    <Grid
      item
      xs={10}
      style={{
        padding: "20px",
        height: "100%",
        fontFamily: "Noto Sans",
        fontWeight: "500",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Container fluid style={{ height: "100%" }}>
        <Row>
          {isList ? (
            <Col
              xs={12}
              style={{
                height: "90vh",
                overflowY: "scroll",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "start",
              }}
            >
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  flexDirection: "row",
                  marginBottom: "10px",
                }}
              >
                <Form.Group controlId="formCompanyFilter" style={{ flex: 1 }}>
                  <Form.Control
                    className="w-100"
                    style={{ width: "100%", borderRadius: "10px" }}
                    as="select"
                    value={selectedCompany}
                    onChange={(e) => {
                      setSelectedCompany(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="">All Organizations</option>
                    {companies.map((company) => (
                      <option key={company._id} value={company._id}>
                        {company.name}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
                <Form.Control
                  style={{ borderRadius: "10px", flex: 1, marginLeft: "10px" }}
                  type="text"
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <Button
                  variant="outline-primary"
                  style={{ borderRadius: "10px", marginLeft: "10px" }}
                  elevation={3}
                >
                  <CSVLink
                    data={courses.map((course) => ({
                      Thumbnail: course.thumbnail,
                      Title: course.title,
                      Description: course.description,
                      Organization:
                        course.type != "demo" ? course.company.name : "Demo",
                    }))} // Pass your students data here
                    filename={"courses.csv"}
                    target="_blank"
                  >
                    Download CSV
                  </CSVLink>
                </Button>
                <Button
                  style={{
                    fontWeight: "600",
                    borderRadius: "10px",
                    marginLeft: "10px",
                  }}
                  elevation={3}
                  className="w-10"
                  variant="primary"
                  type="submit"
                  disabled={isLoading}
                  onClick={(event) => {
                    event.preventDefault();
                    setFormData({
                      title: "",
                      description: "",
                      company: "",
                      userID: localStorage.getItem("userId"), // Assuming you have the userID
                      thumbnail: null,
                      dueDate: null,
                      schedule: getDefaultDateTime(),
                      selectedThumb: null,
                      modules: [],
                    });
                    setIsEdit(false);
                    setIsList(!isList);
                  }}
                >
                  {isList ? "Create Course" : "Cancel"}
                </Button>
                {isList && onTransactionsClick && (
                  <Button
                    style={{
                      fontWeight: "600",
                      borderRadius: "10px",
                      marginLeft: "10px",
                      backgroundColor: "#E1BA66",
                      borderColor: "#E1BA66",
                      color: "#000",
                    }}
                    elevation={3}
                    onClick={onTransactionsClick}
                  >
                    Transactions
                  </Button>
                )}
              </div>
              {courses.length > 0 ? (
                <table className="table table-striped table-bordered table-hover">
                  <thead>
                    <tr>
                      <th>Thumbnail</th>
                      <th>Title/Description</th>
                      <th>Organization</th>
                      <th>Due Date</th>
                      <th>No Of Materials</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* Map through courses data to display each course */}
                    {courses.map((course) => (
                      <tr key={course._id}>
                        <td
                          style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-evenly",
                          }}
                          onClick={() => {
                            onCourseClick(course.company._id, course._id);
                          }}
                        >
                          <div
                            style={{
                              backgroundColor:
                                new Date() < new Date(course.schedule)
                                  ? "grey"
                                  : new Date() >= new Date(course.schedule) &&
                                      new Date() <= new Date(course.dueDate)
                                    ? "green"
                                    : "red",
                              width: "10px",
                              height: "50px",
                            }}
                          />
                          <img
                            src={`${API_URL}/${course.thumbnail}`}
                            height="50"
                            className="d-inline-block align-center"
                            alt="Thumbnail"
                          />
                        </td>
                        <td
                          onClick={() => {
                            onCourseClick(course.company._id, course._id);
                          }}
                        >
                          {course.title}
                          <p
                            style={{
                              margin: "0px",
                              padding: "0px",
                              fontSize: "12px",
                              maxHeight: "2.4em",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              lineHeight: "1.2em",
                            }}
                          >
                            {course.description}
                          </p>
                        </td>
                        <td
                          onClick={() => {
                            onCourseClick(course.company._id, course._id);
                          }}
                        >
                          <p
                            style={{
                              margin: "0px",
                              padding: "0px",
                              fontSize: "14px",
                            }}
                          >
                            {course.type != "demo"
                              ? course.company.name
                              : "Demo"}
                          </p>
                        </td>
                        <td
                          onClick={() => {
                            onCourseClick(course.company._id, course._id);
                          }}
                        >
                          <p
                            style={{
                              margin: "0px",
                              padding: "0px",
                              fontSize: "14px",
                            }}
                          >
                            {new Date(course.dueDate).toDateString()}
                          </p>
                        </td>
                        <td
                          onClick={() => {
                            onCourseClick(course.company._id, course._id);
                          }}
                        >
                          <p
                            style={{
                              margin: "0px",
                              padding: "0px",
                              fontSize: "14px",
                            }}
                          >
                            {course.modules.length} Materials
                          </p>
                        </td>
                        <td>
                          {/* EditNoteIcon */}
                          <EditNoteIcon
                            onClick={(e) => {
                              e.stopPropagation(); // Stop propagation
                              handleEdit(course);
                            }}
                            style={{ color: "green", cursor: "pointer" }}
                          />

                          {/* DeleteSweepIcon */}
                          <DeleteSweepIcon
                            onClick={(e) => {
                              e.stopPropagation(); // Stop propagation
                              handleDelete(course._id);
                            }}
                            style={{ color: "red", cursor: "pointer" }}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div style={{ flex: 1, textAlign: "center" }}>
                  No courses found, please try again!
                </div>
              )}
              <div style={{ flex: 1 }} />
              {courses.length > 0 ? (
                <nav aria-label="Courses pagination">
                  <ul
                    className="pagination"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <li className="page-item">
                      <select
                        className="form-select form-select-sm"
                        aria-label="Default select example"
                        value={itemsPerPage}
                        onChange={(e) => {
                          setCurrentPage(1);
                          setItemsPerPage(parseInt(e.target.value));
                        }}
                        style={{ height: "40px" }} // Set the height to 100%
                      >
                        <option value="7">7 per page</option>
                        <option value="10">10 per page</option>
                        <option value="50">50 per page</option>
                        <option value="100">100 per page</option>
                      </select>
                    </li>
                    <div style={{ width: "10px" }} />
                    {[...Array(totalPages).keys()].map((page) => (
                      <li
                        key={page}
                        className={`page-item ${
                          currentPage === page + 1 ? "active" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(page + 1)}
                        >
                          {page + 1}
                        </button>
                      </li>
                    ))}
                  </ul>
                </nav>
              ) : null}
            </Col>
          ) : (
            <Col xs={12} style={{ height: "90vh", overflowY: "scroll" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "15px",
                }}
              >
                <h4>{isEdit ? "Edit" : "Create"} Course</h4>
                <Button
                  variant="secondary"
                  onClick={() => {
                    setFormData({
                      title: "",
                      description: "",
                      company: "",
                      userID: localStorage.getItem("userId"),
                      thumbnail: null,
                      dueDate: null,
                      schedule: getDefaultDateTime(),
                      selectedThumb: null,
                      modules: [],
                      slug: "",
                      shortDescription: "",
                      websiteLevel: "",
                      duration: "",
                      language: "English",
                      certifications: true,
                      pageContent: "",
                      price: "",
                      originalPrice: "",
                    });
                    setIsEdit(!isEdit);
                    setIsList(!isList);
                  }}
                >
                  Cancel
                </Button>
              </div>
              <Row xs={12}>
                <Col xs={6}>
                  <Form style={{ fontFamily: "Noto Sans" }} className="w-100">
                    {formData.type == "demo" ? null : (
                      <Form.Group controlId="formCompany">
                        <Form.Label
                          style={{ fontWeight: "500", borderRadius: "20px" }}
                        >
                          Organization<span style={{ color: "red" }}> *</span>
                        </Form.Label>
                        <Form.Control
                          className="w-100"
                          style={{ width: "100%", borderRadius: "20px" }}
                          as="select"
                          value={formData.company}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              company: e.target.value,
                            })
                          }
                        >
                          <option value="">Select a organization</option>
                          {companies.map((company) => (
                            <option key={company._id} value={company._id}>
                              {company.name}
                            </option>
                          ))}
                        </Form.Control>
                      </Form.Group>
                    )}
                    <Form.Group controlId="formCourseTitle">
                      <Form.Label
                        style={{ fontWeight: "500", borderRadius: "20px" }}
                      >
                        Title<span style={{ color: "red" }}> *</span>
                      </Form.Label>
                      <Form.Control
                        className="w-100"
                        style={{ width: "100%", borderRadius: "20px" }}
                        type="text"
                        placeholder="Enter course title"
                        value={formData.title}
                        onChange={(e) =>
                          setFormData({ ...formData, title: e.target.value })
                        }
                      />
                    </Form.Group>
                    <Form.Group controlId="formCourseDescription">
                      <Form.Label
                        style={{ fontWeight: "500", borderRadius: "20px" }}
                      >
                        Description
                        {/* <span style={{ color: "red" }}> *</span> */}
                      </Form.Label>
                      <Form.Control
                        className="w-100"
                        maxLength={70}
                        style={{ width: "100%", borderRadius: "20px" }}
                        as="textarea"
                        rows={3}
                        placeholder="Enter course description"
                        value={formData.description}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            description: e.target.value,
                          })
                        }
                      />
                      <p style={{ color: "grey", fontSize: "12px" }}>
                        {formData.description.length}/70
                      </p>{" "}
                      {/* Display character count */}
                    </Form.Group>

                    <Form.Group controlId="formCompany">
                      <Form.Label
                        style={{ fontWeight: "500", borderRadius: "20px" }}
                      >
                        Level<span style={{ color: "red" }}> *</span>
                      </Form.Label>
                      <Form.Control
                        className="w-100"
                        style={{ width: "100%", borderRadius: "20px" }}
                        as="select"
                        value={formData.department}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            department: e.target.value,
                          })
                        }
                      >
                        <option value="">Select a Level</option>
                        {departments.map((department) => (
                          <option key={department._id} value={department._id}>
                            {department.name}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                    <Form.Group controlId="formCompany">
                      <Form.Label
                        style={{ fontWeight: "500", borderRadius: "20px" }}
                      >
                        Grade<span style={{ color: "red" }}> *</span>
                      </Form.Label>
                      <Form.Control
                        className="w-100"
                        style={{ width: "100%", borderRadius: "20px" }}
                        as="select"
                        value={formData.designation}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            designation: e.target.value,
                          })
                        }
                      >
                        <option value="">Select Grade</option>
                        {designations.map((designation) => (
                          <option key={designation._id} value={designation._id}>
                            {designation.name}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                    <Form.Group controlId="dueDate">
                      <Form.Label>
                        Due Date<span style={{ color: "red" }}> *</span>:
                      </Form.Label>
                      <Form.Control
                        type="date"
                        value={formData.dueDate}
                        onChange={(e) =>
                          setFormData({ ...formData, dueDate: e.target.value })
                        }
                        required
                        style={{ marginBottom: "10px" }}
                      />
                    </Form.Group>
                    <Form.Group controlId="scheduleDate">
                      <Form.Label>
                        Schedule Course<span style={{ color: "red" }}> *</span>:
                      </Form.Label>
                      <Form.Control
                        type="datetime-local"
                        value={formData.schedule}
                        onChange={(e) =>
                          setFormData({ ...formData, schedule: e.target.value })
                        }
                        required
                        style={{ marginBottom: "10px" }}
                      />
                    </Form.Group>

                    {/* ===== Website Content Section ===== */}
                    <hr style={{ margin: "20px 0 10px" }} />
                    <h6 style={{ fontWeight: "600", marginBottom: "10px" }}>
                      Website Content (Public Page)
                    </h6>
                    <Form.Group controlId="formSlug">
                      <Form.Label style={{ fontWeight: "500" }}>
                        URL Slug
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="e.g. prarambh (lowercase, no spaces)"
                        value={formData.slug}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            slug: e.target.value
                              .toLowerCase()
                              .replace(/[^a-z0-9-]/g, "-")
                              .replace(/-+/g, "-"),
                          })
                        }
                        style={{ borderRadius: "20px", marginBottom: "8px" }}
                      />
                      <Form.Text className="text-muted">
                        Public URL: /courses/{formData.slug || "your-slug"}
                      </Form.Text>
                    </Form.Group>
                    <Row style={{ marginTop: "8px" }}>
                      <Col xs={6}>
                        <Form.Group controlId="formPrice">
                          <Form.Label style={{ fontWeight: "500" }}>
                            Price (INR)
                          </Form.Label>
                          <Form.Control
                            type="number"
                            min="0"
                            placeholder="e.g. 999"
                            value={formData.price}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                price: e.target.value,
                              })
                            }
                            style={{ borderRadius: "20px" }}
                          />
                        </Form.Group>
                      </Col>
                      <Col xs={6}>
                        <Form.Group controlId="formOriginalPrice">
                          <Form.Label style={{ fontWeight: "500" }}>
                            Original Price (strikethrough)
                          </Form.Label>
                          <Form.Control
                            type="number"
                            min="0"
                            placeholder="e.g. 1499"
                            value={formData.originalPrice}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                originalPrice: e.target.value,
                              })
                            }
                            style={{ borderRadius: "20px" }}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Form.Group
                      controlId="formShortDesc"
                      style={{ marginTop: "8px" }}
                    >
                      <Form.Label style={{ fontWeight: "500" }}>
                        Short Description
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={2}
                        maxLength={200}
                        placeholder="Brief summary for course cards"
                        value={formData.shortDescription}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            shortDescription: e.target.value,
                          })
                        }
                        style={{ borderRadius: "15px" }}
                      />
                      <p style={{ color: "grey", fontSize: "12px" }}>
                        {formData.shortDescription?.length || 0}/200
                      </p>
                    </Form.Group>
                    <Row>
                      <Col xs={6}>
                        <Form.Group controlId="formWebLevel">
                          <Form.Label style={{ fontWeight: "500" }}>
                            Level
                          </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="e.g. Foundation"
                            value={formData.websiteLevel}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                websiteLevel: e.target.value,
                              })
                            }
                            style={{ borderRadius: "20px" }}
                          />
                        </Form.Group>
                      </Col>
                      <Col xs={6}>
                        <Form.Group controlId="formDuration">
                          <Form.Label style={{ fontWeight: "500" }}>
                            Duration
                          </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="e.g. 12 hrs to 14 hrs"
                            value={formData.duration}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                duration: e.target.value,
                              })
                            }
                            style={{ borderRadius: "20px" }}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row style={{ marginTop: "8px" }}>
                      <Col xs={6}>
                        <Form.Group controlId="formLanguage">
                          <Form.Label style={{ fontWeight: "500" }}>
                            Language
                          </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="English"
                            value={formData.language}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                language: e.target.value,
                              })
                            }
                            style={{ borderRadius: "20px" }}
                          />
                        </Form.Group>
                      </Col>
                      <Col xs={6}>
                        <Form.Group
                          controlId="formCerts"
                          style={{ paddingTop: "30px" }}
                        >
                          <Form.Check
                            type="checkbox"
                            label="Certifications Available"
                            checked={formData.certifications}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                certifications: e.target.checked,
                              })
                            }
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Form.Group
                      controlId="formPageContent"
                      style={{ marginTop: "10px" }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Form.Label style={{ fontWeight: "500" }}>
                          Page Content
                        </Form.Label>
                        <Button
                          variant="link"
                          size="sm"
                          style={{ fontSize: "12px", textDecoration: "none" }}
                          onClick={() => setShowRawJson(!showRawJson)}
                        >
                          {showRawJson
                            ? "← Visual Editor"
                            : "Advanced: Edit JSON"}
                        </Button>
                      </div>
                      {showRawJson ? (
                        <>
                          <Form.Control
                            as="textarea"
                            rows={12}
                            placeholder='{"heroTitle": "...", "introParagraphs": [...], "sections": [...]}'
                            value={formData.pageContent}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                pageContent: e.target.value,
                              })
                            }
                            style={{
                              borderRadius: "15px",
                              fontFamily: "monospace",
                              fontSize: "12px",
                            }}
                          />
                          <Form.Text className="text-muted">
                            Raw JSON — edit only if you know the structure.
                          </Form.Text>
                        </>
                      ) : (
                        <PageContentEditor
                          value={formData.pageContent}
                          onChange={(jsonStr) =>
                            setFormData({ ...formData, pageContent: jsonStr })
                          }
                        />
                      )}
                    </Form.Group>
                    {/* ===== End Website Content Section ===== */}

                    <Button
                      style={{
                        fontWeight: "600",
                        borderRadius: "20px",
                        marginTop: "15px",
                        marginBottom: "10px",
                      }}
                      elevation={3}
                      className="w-100"
                      variant="primary"
                      type="submit"
                      onClick={isEdit ? handleUpdate : handleSubmit}
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : null}
                      {isEdit ? "Edit" : "Create"} Course
                    </Button>
                  </Form>
                </Col>
                <Col
                  xs={6}
                  style={{
                    height: "90vh",
                    overflowY: "scroll",
                    marginBottom: "10px",
                  }}
                >
                  {isLoading ? null : (
                    <Form.Group
                      controlId="formCourseThumbnail"
                      style={{ marginTop: "10px" }}
                    >
                      <Form.Label
                        style={{ fontWeight: "500", borderRadius: "20px" }}
                      >
                        Upload Thumbnail<span style={{ color: "red" }}> *</span>
                      </Form.Label>
                      <Form.Control
                        type="file"
                        className="w-100"
                        placeholder="Select Thumbnail"
                        onChange={handleFileChange}
                        accept=".png,.jpg,.jpeg"
                        style={{ width: "100%", borderRadius: "20px" }}
                      />
                      <Form.Label
                        style={{
                          fontWeight: "500",
                          borderRadius: "20px",
                          fontSize: "12px",
                        }}
                      >
                        * If thumbnail is uploaded default will be overridden.
                      </Form.Label>
                    </Form.Group>
                  )}
                  {/* <div style={{ alignItems: 'center', display: 'flex', width: '100%', flexDirection: 'column' }}>
                                    <Form.Group controlId="formCourseThumbnail" style={{ marginTop: '10px', fontFamily: 'Dosis', }}><Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>OR</Form.Label></Form.Group>
                                </div>
                                <Form.Group controlId="formCourseThumbnail"><Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Select from one of these:</Form.Label></Form.Group>
                                <Container fluid>
                                    <Row noGutters className="flex-nowrap overflow-auto">
                                        {imageUrls.filter((e) => e.type == formData.type).map((url, index) => (
                                            <Col key={index} className="mb-1" style={{ borderRadius: '5px', minWidth: '150px', padding: '2.5px', backgroundColor: formData.selectedThumb === url.thumbnail ? 'blue' : 'transparent', maxWidth: '160px', flex: '0 0 auto' }}>
                                                <img
                                                    src={`${API_URL}/` + url.thumbnail}
                                                    alt={`Image ${index + 1}`}
                                                    className={`img-fluid`}
                                                    style={{ borderRadius: '5px', }}
                                                    onClick={() => {
                                                        setFormData({ ...formData, selectedThumb: url.thumbnail });
                                                    }}
                                                />
                                            </Col>
                                        ))
                                        }
                                    </Row>
                                </Container> */}
                  <Form.Group controlId="formCourseThumbnail">
                    <Form.Label
                      style={{
                        fontWeight: "500",
                        borderRadius: "20px",
                        marginTop: "10px",
                      }}
                    >
                      Select course module (Multiple allowed)
                      <span style={{ color: "red" }}> *</span>:
                    </Form.Label>
                    <Container fluid>
                      <Form.Group controlId="search">
                        <Form.Control
                          type="text"
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          placeholder="Search by title..."
                          style={{ marginBottom: "10px" }}
                        />
                      </Form.Group>
                      <Row noGutters className="flex-nowrap overflow-auto">
                        {filteredThumbnails.map((url, index) => (
                          <Col
                            key={index}
                            className="mb-1"
                            style={{
                              borderRadius: "5px",
                              minWidth: "150px",
                              padding: "2.5px",
                              backgroundColor: formData.modules.some(
                                (e) => e === url._id,
                              )
                                ? "blue"
                                : "transparent",
                              maxWidth: "160px",
                              flex: "0 0 auto",
                              marginRight: "10px",
                            }}
                          >
                            <img
                              src={`${API_URL}/` + url.thumbnail}
                              alt={`Image ${index + 1}`}
                              className="img-fluid"
                              style={{ borderRadius: "5px" }}
                              onClick={() => {
                                if (
                                  formData.modules.some((e) => e === url._id)
                                ) {
                                  setFormData({
                                    ...formData,
                                    modules: formData.modules.filter(
                                      (imageUrl) => {
                                        return imageUrl !== url._id;
                                      },
                                    ),
                                  });
                                } else {
                                  setFormData({
                                    ...formData,
                                    modules: [...formData.modules, url._id],
                                  });
                                }
                              }}
                            />
                            <Form.Label
                              style={{
                                fontWeight: "500",
                                color: formData.modules.some(
                                  (e) => e === url._id,
                                )
                                  ? "white"
                                  : "black",
                                borderRadius: "20px",
                                fontSize: "12px",
                              }}
                            >
                              {url.title}
                            </Form.Label>
                          </Col>
                        ))}
                      </Row>
                    </Container>
                  </Form.Group>
                </Col>
              </Row>
            </Col>
          )}
        </Row>
      </Container>
    </Grid>
  );
};

export default CourseFragment;
